export default {
  "silhouette": [{
    "name": "./images/1-Silhouettes/01Silhouette_ALine01.png",
    "description": "01Silhouette_ALine01",
    "imageId": "af20362d-7836-4c39-a104-d244110cb970",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/01Silhouette_ALine01_X2.png",
    "description": "01Silhouette_ALine01_X2",
    "imageId": "6da531a7-93c5-44d3-a3e8-f157cbc46beb",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/02Silhouette_Column02.png",
    "description": "02Silhouette_Column02",
    "imageId": "0af6555e-c7f1-4c2a-a3ab-38fc7bfec614",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/02Silhouette_Column02_X2.png",
    "description": "02Silhouette_Column02_X2",
    "imageId": "855a7e5a-9e0f-4b3c-a641-1ca7274e5a99",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/03Silhouette_MermaidAndTrumpet04.png",
    "description": "03Silhouette_MermaidAndTrumpet04",
    "imageId": "ac1411a1-3d99-453e-808c-b3950c054181",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/03Silhouette_MermaidAndTrumpet04_X2.png",
    "description": "03Silhouette_MermaidAndTrumpet04_X2",
    "imageId": "a9cbe72d-20a8-4021-8bfa-d27cc95357b6",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/04Silhouette_BallGown03.png",
    "description": "04Silhouette_BallGown03",
    "imageId": "7f4c3e9f-25c8-4965-8b4e-536cc3e41efc",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/04Silhouette_BallGown03_X2.png",
    "description": "04Silhouette_BallGown03_X2",
    "imageId": "5f313722-92eb-4181-ad58-2baaf9b021e1",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/05Silhouette_Column01.png",
    "description": "05Silhouette_Column01",
    "imageId": "5adb247d-e8db-4d4c-a814-2c5b22378e6b",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/05Silhouette_Column01_X2.png",
    "description": "05Silhouette_Column01_X2",
    "imageId": "cd3c694b-7f6f-4679-8341-0a559d586840",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/06Silhouette_Jumpsuit03.png",
    "description": "06Silhouette_Jumpsuit03",
    "imageId": "f16cc74d-0c3e-43c8-8925-9c5131c32c96",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/06Silhouette_Jumpsuit03_X2.png",
    "description": "06Silhouette_Jumpsuit03_X2",
    "imageId": "18448606-23e2-46ce-8808-c3cc147f6d69",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/07Silhouette_ALine03.png",
    "description": "07Silhouette_ALine03",
    "imageId": "8aef5ced-031d-4d0b-905a-24b0b09f5a2d",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/07Silhouette_ALine03_X2.png",
    "description": "07Silhouette_ALine03_X2",
    "imageId": "43fc4944-2852-43e7-878a-ea95ad37e8ae",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/08Silhouette_MermaidAndTrumpet01.png",
    "description": "08Silhouette_MermaidAndTrumpet01",
    "imageId": "c43f7684-d3f1-4646-91c9-2864030c2fc9",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/08Silhouette_MermaidAndTrumpet01_X2.png",
    "description": "08Silhouette_MermaidAndTrumpet01_X2",
    "imageId": "3b606584-9e23-48cc-a944-c0213b4f064c",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/09Silhouette_BallGown04.png",
    "description": "09Silhouette_BallGown04",
    "imageId": "5b48b40a-db9a-4721-8d16-b2027f80a940",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/09Silhouette_BallGown04_X2.png",
    "description": "09Silhouette_BallGown04_X2",
    "imageId": "5278a040-8b05-4a74-8902-daae2d52a169",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/10Silhouette_MermaidAndTrumpet03.png",
    "description": "10Silhouette_MermaidAndTrumpet03",
    "imageId": "45625e53-5810-4599-8de0-eace9b7946e5",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/10Silhouette_MermaidAndTrumpet03_X2.png",
    "description": "10Silhouette_MermaidAndTrumpet03_X2",
    "imageId": "19ee9136-5745-494f-b8a1-0cb60075bb82",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/11Silhouette_FitAndFlare01.png",
    "description": "11Silhouette_FitAndFlare01",
    "imageId": "5faf45af-557d-4a91-83d5-2b734fbf0458",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/11Silhouette_FitAndFlare01_X2.png",
    "description": "11Silhouette_FitAndFlare01_X2",
    "imageId": "c1fc039a-1d62-4ac0-94e3-ea02ea36e916",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/12Silhouette_PantsuitsSeparates03.png",
    "description": "12Silhouette_PantsuitsSeparates03",
    "imageId": "a2426999-74d8-4f54-bb27-248e7d8f35af",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/12Silhouette_PantsuitsSeparates03_X2.png",
    "description": "12Silhouette_PantsuitsSeparates03_X2",
    "imageId": "d17fa61b-7fa9-44a4-9a20-42e6a01831d6",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/13Silhouette_Jumpsuit02.png",
    "description": "13Silhouette_Jumpsuit02",
    "imageId": "c914c815-1269-4229-9a12-28bc6b9537d3",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/13Silhouette_Jumpsuit02_X2.png",
    "description": "13Silhouette_Jumpsuit02_X2",
    "imageId": "3d6685ea-bb89-4523-b5a6-9abc0930a775",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/14Silhouette_ALine02.png",
    "description": "14Silhouette_ALine02",
    "imageId": "1fd76a59-482a-4bb0-b3a1-8d967432650e",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/14Silhouette_ALine02_X2.png",
    "description": "14Silhouette_ALine02_X2",
    "imageId": "62eef874-ec5c-42a2-aaf5-f13c1ada3be5",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/15Silhouette_Sheath02.png",
    "description": "15Silhouette_Sheath02",
    "imageId": "530bd24b-ade7-425b-9169-cccff7bcaa31",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/15Silhouette_Sheath02_X2.png",
    "description": "15Silhouette_Sheath02_X2",
    "imageId": "0abe9a7b-72fb-4d88-bf7d-2a359eb53765",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/16Silhouette_Jumpsuit04.png",
    "description": "16Silhouette_Jumpsuit04",
    "imageId": "0af88d63-0acd-4b47-a88d-f1d8a9e1a12c",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/16Silhouette_Jumpsuit04_X2.png",
    "description": "16Silhouette_Jumpsuit04_X2",
    "imageId": "282f25ed-7958-4876-85b4-9384345191a0",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/17Silhouette_MermaidAndTrumpet02.png",
    "description": "17Silhouette_MermaidAndTrumpet02",
    "imageId": "156f588a-aeb7-4226-8041-a7218fdb4fc8",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/17Silhouette_MermaidAndTrumpet02_X2.png",
    "description": "17Silhouette_MermaidAndTrumpet02_X2",
    "imageId": "6400fd22-7b40-41e0-ad2b-c9afe0bfa00e",
    "facet": "mermaid",
    "seoUrl": "mermaid"
  }, {
    "name": "./images/1-Silhouettes/18Silhouette_FitAndFlare02.png",
    "description": "18Silhouette_FitAndFlare02",
    "imageId": "3c7952ea-9e52-411f-afe1-71d94d5757e8",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/18Silhouette_FitAndFlare02_X2.png",
    "description": "18Silhouette_FitAndFlare02_X2",
    "imageId": "77e30b14-73c9-429d-987e-b22b58901d09",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/19Silhouette_BallGown02.png",
    "description": "19Silhouette_BallGown02",
    "imageId": "b8cb7cb7-9652-4dba-b254-ab5073ced1e3",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/19Silhouette_BallGown02_X2.png",
    "description": "19Silhouette_BallGown02_X2",
    "imageId": "c68ba993-3227-4bb2-98ee-e0b49633005d",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/20Silhouette_ALine04.png",
    "description": "20Silhouette_ALine04",
    "imageId": "3216e232-6821-40dd-9129-985d16cef2a7",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/20Silhouette_ALine04_X2.png",
    "description": "20Silhouette_ALine04_X2",
    "imageId": "c6227f96-f447-4eb2-8840-9789f53c63e5",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/21Silhouette_FitAndFlare03.png",
    "description": "21Silhouette_FitAndFlare03",
    "imageId": "dae55bdf-1529-405d-a676-939a0b121fcb",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/21Silhouette_FitAndFlare03_X2.png",
    "description": "21Silhouette_FitAndFlare03_X2",
    "imageId": "7df18a8f-eff0-403a-995f-bc8f304264bb",
    "facet": "fit-and-flare",
    "seoUrl": "fit-and-flare"
  }, {
    "name": "./images/1-Silhouettes/22Silhouette_BallGown01.png",
    "description": "22Silhouette_BallGown01",
    "imageId": "84b96c95-70e3-4861-84b2-6411c8630222",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/22Silhouette_BallGown01_X2.png",
    "description": "22Silhouette_BallGown01_X2",
    "imageId": "c44cfe3d-8fba-4b17-a256-f4d1491c8fc3",
    "facet": "ball-gown",
    "seoUrl": "ball-gown"
  }, {
    "name": "./images/1-Silhouettes/23Silhouette_Slip02.png",
    "description": "23Silhouette_Slip02",
    "imageId": "bb16e042-7d9a-4f8e-9cec-6b61e052e4d3",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/23Silhouette_Slip02_X2.png",
    "description": "23Silhouette_Slip02_X2",
    "imageId": "57bad62b-8e56-4617-ae62-b590f37a6c80",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/24Silhouette_Sheath03.png",
    "description": "24Silhouette_Sheath03",
    "imageId": "05d79122-7d90-4576-8bc3-facc4c941b9d",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/24Silhouette_Sheath03_X2.png",
    "description": "24Silhouette_Sheath03_X2",
    "imageId": "a345be29-7e66-49c9-acf0-f86ad683ceba",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/25Silhouette_PantsuitsSeparates04.png",
    "description": "25Silhouette_PantsuitsSeparates04",
    "imageId": "a34c0fe2-2bff-409d-a976-bfed40ced88b",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/25Silhouette_PantsuitsSeparates04_X2.png",
    "description": "25Silhouette_PantsuitsSeparates04_X2",
    "imageId": "d78a86b7-1ad3-4c45-b24b-f4f4efee0768",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/26Silhouette_Slip03.png",
    "description": "26Silhouette_Slip03",
    "imageId": "711b9ed6-8d5f-4b9b-b429-f67912f5ad3a",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/26Silhouette_Slip03_X2.png",
    "description": "26Silhouette_Slip03_X2",
    "imageId": "8ed7fb4e-30af-4806-9f6d-358383759838",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/27Silhouette_Column03.png",
    "description": "27Silhouette_Column03",
    "imageId": "2b4fa494-ea42-415d-bcbd-7c3fe770e0eb",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/27Silhouette_Column03_X2.png",
    "description": "27Silhouette_Column03_X2",
    "imageId": "1c85c726-4537-42f5-b375-27077e4d1f73",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/28Silhouette_Column04.png",
    "description": "28Silhouette_Column04",
    "imageId": "d98fef40-a9e9-44c7-a7e9-a424e1ea2c95",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/28Silhouette_Column04_X2.png",
    "description": "28Silhouette_Column04_X2",
    "imageId": "1a837b05-e9f2-4be0-8890-923cb1de102b",
    "facet": "column",
    "seoUrl": "column"
  }, {
    "name": "./images/1-Silhouettes/29Silhouette_Sheath04.png",
    "description": "29Silhouette_Sheath04",
    "imageId": "4a122742-d59c-4a0f-ad7c-00d273d7ab41",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/29Silhouette_Sheath04_X2.png",
    "description": "29Silhouette_Sheath04_X2",
    "imageId": "09d74995-34ec-4eb4-ae9e-dbd8ee609e1d",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/30Silhouette_PantsuitsSeparates02.png",
    "description": "30Silhouette_PantsuitsSeparates02",
    "imageId": "878e8952-8d8b-4517-a2fc-07852ab7d793",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/30Silhouette_PantsuitsSeparates02_X2.png",
    "description": "30Silhouette_PantsuitsSeparates02_X2",
    "imageId": "fd6af52a-8fc3-4b76-b019-1aba07da3547",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/31Silhouette_ALine05.png",
    "description": "31Silhouette_ALine05",
    "imageId": "47959f79-e355-4322-a67e-1e49fcd0a795",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/31Silhouette_ALine05_X2.png",
    "description": "31Silhouette_ALine05_X2",
    "imageId": "8c6c36e7-3e11-49c7-ac66-ef693ce83e8e",
    "facet": "a-line",
    "seoUrl": "a-line"
  }, {
    "name": "./images/1-Silhouettes/32Silhouette_Slip01.png",
    "description": "32Silhouette_Slip01",
    "imageId": "bce05cf7-cfe3-4645-8de8-3c9bca1cd555",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/32Silhouette_Slip01_X2.png",
    "description": "32Silhouette_Slip01_X2",
    "imageId": "8ba9d088-6ee6-4e4f-a9c3-24f17b29750f",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/33Silhouette_Slip04.png",
    "description": "33Silhouette_Slip04",
    "imageId": "603815b4-a1f9-42df-a62e-4f86eae3ed03",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/33Silhouette_Slip04_X2.png",
    "description": "33Silhouette_Slip04_X2",
    "imageId": "6bb9457e-c85d-459d-9c5d-a65f40372195",
    "facet": "slip",
    "seoUrl": "slip"
  }, {
    "name": "./images/1-Silhouettes/34Silhouette_Sheath01.png",
    "description": "34Silhouette_Sheath01",
    "imageId": "2c192a1e-4a35-43a9-b852-5d3dd8d94c94",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/34Silhouette_Sheath01_X2.png",
    "description": "34Silhouette_Sheath01_X2",
    "imageId": "273744fc-e56e-4558-a3e4-70e4c7085fe1",
    "facet": "sheath",
    "seoUrl": "sheath"
  }, {
    "name": "./images/1-Silhouettes/35Silhouette_Jumpsuit01.png",
    "description": "35Silhouette_Jumpsuit01",
    "imageId": "95526e2f-54d1-44f0-ab28-4a23b54486eb",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/35Silhouette_Jumpsuit01_X2.png",
    "description": "35Silhouette_Jumpsuit01_X2",
    "imageId": "a6c57fb5-6cc9-45b1-8fb8-e6c8759d3202",
    "facet": "jumpsuit",
    "seoUrl": "jumpsuit"
  }, {
    "name": "./images/1-Silhouettes/36Silhouette_PantsuitsSeparates01.png",
    "description": "36Silhouette_PantsuitsSeparates01",
    "imageId": "6e3b5add-fd37-4ba2-8816-2c6e9023c952",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }, {
    "name": "./images/1-Silhouettes/36Silhouette_PantsuitsSeparates01_X2.png",
    "description": "36Silhouette_PantsuitsSeparates01_X2",
    "imageId": "b45a173e-aa07-4bf6-9849-5506a66b7326",
    "facet": "pantsuit",
    "seoUrl": "pantsuit"
  }],
  "neckline": [{
    "name": "./images/2-Necklines/01Neckline_VNeck02.png",
    "description": "01Neckline_VNeck02",
    "imageId": "3df177d6-01e5-4939-9b64-91e0e33541f7",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/01Neckline_VNeck02_X2.png",
    "description": "01Neckline_VNeck02_X2",
    "imageId": "5dbc9ec3-b884-4035-87ec-1edcdfef418e",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/02Neckline_Square02.png",
    "description": "02Neckline_Square02",
    "imageId": "51665f79-a5da-49f2-ae39-b7a68db5f2a9",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/02Neckline_Square02_X2.png",
    "description": "02Neckline_Square02_X2",
    "imageId": "d23593e9-66ee-4041-ac8f-3a040337ff4e",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/03Neckline_Sweetheart01.png",
    "description": "03Neckline_Sweetheart01",
    "imageId": "6e913f1a-d8dc-45da-8420-8736677dda9e",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/03Neckline_Sweetheart01_X2.png",
    "description": "03Neckline_Sweetheart01_X2",
    "imageId": "8252b43c-5406-44df-98ea-0839aa566644",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/04Neckline_VNeck01.png",
    "description": "04Neckline_VNeck01",
    "imageId": "32d5799a-9ea3-4e80-9a31-9bdd9e51b597",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/04Neckline_VNeck01_X2.png",
    "description": "04Neckline_VNeck01_X2",
    "imageId": "f1110503-4393-4bd1-8495-ac88ad3a9134",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/05Neckline_Straight03.png",
    "description": "05Neckline_Straight03",
    "imageId": "a43af80e-e8a7-4168-a183-5fc4d9840fab",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/05Neckline_Straight03_X2.png",
    "description": "05Neckline_Straight03_X2",
    "imageId": "7b14eae3-eb8d-44eb-a226-7b6df76af9cc",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/06Neckline_Halter03.png",
    "description": "06Neckline_Halter03",
    "imageId": "c7e7c397-a86c-4b2a-8e17-b80213207673",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/06Neckline_Halter03_X2.png",
    "description": "06Neckline_Halter03_X2",
    "imageId": "41da0952-4875-4cf9-ae84-95d451101bad",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/07Neckline_Scoop02.png",
    "description": "07Neckline_Scoop02",
    "imageId": "21c4efae-dcbe-40ad-838f-c9590d807f93",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/07Neckline_Scoop02_X2.png",
    "description": "07Neckline_Scoop02_X2",
    "imageId": "285ecc1d-4144-4b23-aa41-cd2a6cecaac3",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/08Neckline_Halter01.png",
    "description": "08Neckline_Halter01",
    "imageId": "0f6eaebb-b56b-4964-8971-015eb412255d",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/08Neckline_Halter01_X2.png",
    "description": "08Neckline_Halter01_X2",
    "imageId": "fed4c329-2a1f-4fce-b785-4ec4fff3525a",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/09Neckline_OffTheShoulders01.png",
    "description": "09Neckline_OffTheShoulders01",
    "imageId": "5ecb1dad-22f0-4b21-8f9c-ce9b5c46e246",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/09Neckline_OffTheShoulders01_X2.png",
    "description": "09Neckline_OffTheShoulders01_X2",
    "imageId": "701ce1eb-dcc1-4bf4-8c2c-29dcd9497c7d",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/10Neckline_Illusion02.png",
    "description": "10Neckline_Illusion02",
    "imageId": "48c3708d-dfab-4ba9-a25e-d7cfc8bdad63",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/10Neckline_Illusion02_X2.png",
    "description": "10Neckline_Illusion02_X2",
    "imageId": "a5a4e4ba-60d3-4a0f-b6ff-f4c4b7e75a8a",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/11Neckline_Bateau03.png",
    "description": "11Neckline_Bateau03",
    "imageId": "4d4a6dbc-5e29-4aaf-9f45-eabd18e223c9",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/11Neckline_Bateau03_X2.png",
    "description": "11Neckline_Bateau03_X2",
    "imageId": "f7c57005-6678-43f6-91b6-4c07dd732854",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/12Neckline_Scoop01.png",
    "description": "12Neckline_Scoop01",
    "imageId": "f5d1a0f9-a105-42f2-bc82-b0505410ab8a",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/12Neckline_Scoop01_X2.png",
    "description": "12Neckline_Scoop01_X2",
    "imageId": "6b826139-b486-4423-9e17-8c45f59eba96",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/13Neckline_QueenAnne03.png",
    "description": "13Neckline_QueenAnne03",
    "imageId": "7b8a75c8-4d47-4b36-b7e0-e67a43ef59f0",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/13Neckline_QueenAnne03_X2.png",
    "description": "13Neckline_QueenAnne03_X2",
    "imageId": "162b8875-5a07-4aea-aece-2f77fc2c3e46",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/14Neckline_Sweetheart03.png",
    "description": "14Neckline_Sweetheart03",
    "imageId": "2a4890e6-12da-4002-b0be-a18d38601035",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/14Neckline_Sweetheart03_X2.png",
    "description": "14Neckline_Sweetheart03_X2",
    "imageId": "5b4cade5-ace6-43a5-b94b-100b44690ead",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/15Neckline_OneShoulder02.png",
    "description": "15Neckline_OneShoulder02",
    "imageId": "6b7883c9-e907-43bd-bb8c-cb60d149a229",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/15Neckline_OneShoulder02_X2.png",
    "description": "15Neckline_OneShoulder02_X2",
    "imageId": "8bc7bc3c-3049-472f-9e2c-df1ce85f8d31",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/16Neckline_Square03.png",
    "description": "16Neckline_Square03",
    "imageId": "084126c8-e2a4-4006-b04f-a6cb359a69c8",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/16Neckline_Square03_X2.png",
    "description": "16Neckline_Square03_X2",
    "imageId": "57572e68-3bb3-40fa-8c7d-b50b515612c9",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/17Neckline_Cowl01.png",
    "description": "17Neckline_Cowl01",
    "imageId": "1b92f4d1-03f0-444c-b09f-7b73f7e3dedf",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/17Neckline_Cowl01_X2.png",
    "description": "17Neckline_Cowl01_X2",
    "imageId": "15d73d31-9085-42d8-9014-5fb0761da9f8",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/18Neckline_VNeck03.png",
    "description": "18Neckline_VNeck03",
    "imageId": "26603bee-c182-4564-8f5c-c9deab2a1af0",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/18Neckline_VNeck03_X2.png",
    "description": "18Neckline_VNeck03_X2",
    "imageId": "8a7f1884-311d-4f99-b771-38d4a19ece6d",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/19Neckline_Straight01.png",
    "description": "19Neckline_Straight01",
    "imageId": "7b9cfc43-63b7-460e-afe3-33dd0fb445c7",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/19Neckline_Straight01_X2.png",
    "description": "19Neckline_Straight01_X2",
    "imageId": "14cbb3ed-b42b-45d2-b36d-3bf2b0036ea2",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/20Neckline_Illusion01.png",
    "description": "20Neckline_Illusion01",
    "imageId": "a0007375-33fa-4940-b23d-327fde85f1c0",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/20Neckline_Illusion01_X2.png",
    "description": "20Neckline_Illusion01_X2",
    "imageId": "46b8ca23-e7ad-4e8d-b2f9-6f47f7deee58",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/21Neckline_High01.png",
    "description": "21Neckline_High01",
    "imageId": "66e4db8c-653e-47d2-a09f-03391eb2a4a0",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/21Neckline_High01_X2.png",
    "description": "21Neckline_High01_X2",
    "imageId": "ee5629c1-0253-4679-8a59-da9095d2d7e7",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/22Neckline_Bateau01.png",
    "description": "22Neckline_Bateau01",
    "imageId": "3c830992-1977-42f8-afb5-e649e75f4d93",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/22Neckline_Bateau01_X2.png",
    "description": "22Neckline_Bateau01_X2",
    "imageId": "1219f0f7-3453-438d-9e58-b5b20696b908",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/23Neckline_High02.png",
    "description": "23Neckline_High02",
    "imageId": "f3275dc9-4f85-452b-b0eb-b5236c80fcd5",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/23Neckline_High02_X2.png",
    "description": "23Neckline_High02_X2",
    "imageId": "71acc99c-9e88-4a53-a2ab-458944637abc",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/24Neckline_Cowl03.png",
    "description": "24Neckline_Cowl03",
    "imageId": "3f8dfca6-1d08-4f5d-bc43-adfeb1dcbe22",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/24Neckline_Cowl03_X2.png",
    "description": "24Neckline_Cowl03_X2",
    "imageId": "81cdca48-e05f-49b6-bcee-772c37d6ee5b",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/25Neckline_Illusion03.png",
    "description": "25Neckline_Illusion03",
    "imageId": "7531437c-ecfa-4dca-bc20-b61785d3e32e",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/25Neckline_Illusion03_X2.png",
    "description": "25Neckline_Illusion03_X2",
    "imageId": "d6b9d488-a451-4f80-8953-3b4a380a2279",
    "facet": "illusion",
    "seoUrl": "illusion-neckline"
  }, {
    "name": "./images/2-Necklines/26Neckline_Scoop03.png",
    "description": "26Neckline_Scoop03",
    "imageId": "86d5df52-19b0-4c66-bd18-91081f2734c0",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/26Neckline_Scoop03_X2.png",
    "description": "26Neckline_Scoop03_X2",
    "imageId": "77c9a404-12c1-40cf-8876-05c86a1f6075",
    "facet": "scoop",
    "seoUrl": "scoop"
  }, {
    "name": "./images/2-Necklines/27Neckline_QueenAnne02.png",
    "description": "27Neckline_QueenAnne02",
    "imageId": "32bc4476-d3e3-4938-9266-5ce9f3035f7f",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/27Neckline_QueenAnne02_X2.png",
    "description": "27Neckline_QueenAnne02_X2",
    "imageId": "753d8980-9962-4ca6-8aa1-e78f36bbc568",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/28Neckline_OffTheShoulders02.png",
    "description": "28Neckline_OffTheShoulders02",
    "imageId": "5f6211cf-6f9b-4101-9b3e-680c42d63f55",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/28Neckline_OffTheShoulders02_X2.png",
    "description": "28Neckline_OffTheShoulders02_X2",
    "imageId": "2c8199ad-c7cc-438a-98b7-75fe35037f99",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/29Neckline_OffTheShoulders03.png",
    "description": "29Neckline_OffTheShoulders03",
    "imageId": "00c0216c-1ee0-4fd3-818e-b4fba86bc37f",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/29Neckline_OffTheShoulders03_X2.png",
    "description": "29Neckline_OffTheShoulders03_X2",
    "imageId": "e2175632-05fd-4ba5-8089-776bece560b0",
    "facet": "off-the-shoulder",
    "seoUrl": "off-the-shoulder"
  }, {
    "name": "./images/2-Necklines/30Neckline_Sweetheart02.png",
    "description": "30Neckline_Sweetheart02",
    "imageId": "19fa723b-eb9c-4c78-b144-98bd98effeb9",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/30Neckline_Sweetheart02_X2.png",
    "description": "30Neckline_Sweetheart02_X2",
    "imageId": "ca562e55-1070-45c7-be9b-886b661c9fe5",
    "facet": "sweetheart",
    "seoUrl": "sweetheart"
  }, {
    "name": "./images/2-Necklines/31Neckline_OneShoulder03.png",
    "description": "31Neckline_OneShoulder03",
    "imageId": "ff54295d-7fe9-4818-853f-b3fcb894ebda",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/31Neckline_OneShoulder03_X2.png",
    "description": "31Neckline_OneShoulder03_X2",
    "imageId": "24211715-7fb6-4b1c-9ca6-1dea38e48bbb",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/32Neckline_Straight02.png",
    "description": "32Neckline_Straight02",
    "imageId": "ed18662f-456f-4568-9d63-0e1f46d00af5",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/32Neckline_Straight02_X2.png",
    "description": "32Neckline_Straight02_X2",
    "imageId": "3be20069-7e01-40dc-8d99-5acf09f2bce6",
    "facet": "straight-neck",
    "seoUrl": "straight-neck"
  }, {
    "name": "./images/2-Necklines/33Neckline_Halter02.png",
    "description": "33Neckline_Halter02",
    "imageId": "c41210ee-1201-47a2-a1ec-80136124e631",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/33Neckline_Halter02_X2.png",
    "description": "33Neckline_Halter02_X2",
    "imageId": "94772d1f-51b8-418d-9c53-5401a5344a7e",
    "facet": "halter",
    "seoUrl": "halter"
  }, {
    "name": "./images/2-Necklines/34Neckline_Square01.png",
    "description": "34Neckline_Square01",
    "imageId": "4d60b548-2c3b-4d2f-82a9-ec1f095663ea",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/34Neckline_Square01_X2.png",
    "description": "34Neckline_Square01_X2",
    "imageId": "8e2c9cb3-bb56-4a0e-ae83-436e0d90505f",
    "facet": "square",
    "seoUrl": "square"
  }, {
    "name": "./images/2-Necklines/35Neckline_High03.png",
    "description": "35Neckline_High03",
    "imageId": "54b7e3eb-b2b5-4feb-9130-85583eba527c",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/35Neckline_High03_X2.png",
    "description": "35Neckline_High03_X2",
    "imageId": "d5dd2765-9dfd-4b53-a3d2-2e2499e93872",
    "facet": "high-neck",
    "seoUrl": "high-neck"
  }, {
    "name": "./images/2-Necklines/36Neckline_OneShoulder01.png",
    "description": "36Neckline_OneShoulder01",
    "imageId": "a21cbdb0-63db-4180-bfb7-c2017179e105",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/36Neckline_OneShoulder01_X2.png",
    "description": "36Neckline_OneShoulder01_X2",
    "imageId": "5909e7ff-64c7-4be7-b2b9-cd32701a9e02",
    "facet": "one-shoulder",
    "seoUrl": "one-shoulder"
  }, {
    "name": "./images/2-Necklines/37Neckline_Bateau02.png",
    "description": "37Neckline_Bateau02",
    "imageId": "c9f2df06-4592-41d2-9eb1-a6655ede3f2b",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/37Neckline_Bateau02_X2.png",
    "description": "37Neckline_Bateau02_X2",
    "imageId": "0b137610-d47d-496b-8a11-339372c76061",
    "facet": "bateau",
    "seoUrl": "bateau"
  }, {
    "name": "./images/2-Necklines/38Neckline_Cowl02.png",
    "description": "38Neckline_Cowl02",
    "imageId": "f14456bc-da58-4bf2-b1a1-2341b94e6226",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/38Neckline_Cowl02_X2.png",
    "description": "38Neckline_Cowl02_X2",
    "imageId": "678e1b27-e3ea-4055-9afb-43264370a8d4",
    "facet": "cowl-neck",
    "seoUrl": "cowl-neck"
  }, {
    "name": "./images/2-Necklines/39Neckline_QueenAnne01.png",
    "description": "39Neckline_QueenAnne01",
    "imageId": "a88e8d10-a48e-4d67-884e-8ef4883835ab",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/39Neckline_QueenAnne01_X2.png",
    "description": "39Neckline_QueenAnne01_X2",
    "imageId": "9914648b-fbc4-4d11-891c-d8ede1976ed5",
    "facet": "queen-anne-neck",
    "seoUrl": "queen-anne-neck"
  }, {
    "name": "./images/2-Necklines/40Neckline_VNeck04.png",
    "description": "40Neckline_VNeck04",
    "imageId": "3db4d496-4488-410f-8f47-18c9733c294f",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }, {
    "name": "./images/2-Necklines/40Neckline_VNeck04_X2.png",
    "description": "40Neckline_VNeck04_X2",
    "imageId": "99088a42-5266-4f34-8fba-479151bc1d2d",
    "facet": "v-neck",
    "seoUrl": "v-neck"
  }],
  "sleeves": [{
    "name": "./images/3-Sleeves/01Sleeves_SpaghettiStraps03.png",
    "description": "01Sleeves_SpaghettiStraps03",
    "imageId": "a11167fa-bbc7-456c-bfbf-15bc053bc82a",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/01Sleeves_SpaghettiStraps03_X2.png",
    "description": "01Sleeves_SpaghettiStraps03_X2",
    "imageId": "20c5a895-77c9-46bb-b2b3-dd8295ca4893",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/02Sleeves_Illusion03.png",
    "description": "02Sleeves_Illusion03",
    "imageId": "5ed22739-a104-4077-b50b-a04680b2320a",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/02Sleeves_Illusion03_X2.png",
    "description": "02Sleeves_Illusion03_X2",
    "imageId": "05b7b4f2-55bb-4a80-b9ef-879c0399389c",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/03Sleeves_Strapless03.png",
    "description": "03Sleeves_Strapless03",
    "imageId": "2aa5af91-c845-4fff-a30e-4ed0f603bde8",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/03Sleeves_Strapless03_X2.png",
    "description": "03Sleeves_Strapless03_X2",
    "imageId": "2e474687-bdee-4ab9-81b7-b30dc15a0f1f",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/04Sleeves_Puff04.png",
    "description": "04Sleeves_Puff04",
    "imageId": "a14e7a5f-c768-409e-ab1c-8546f9ab0800",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/04Sleeves_Puff04_X2.png",
    "description": "04Sleeves_Puff04_X2",
    "imageId": "d15f6d58-f730-4f36-b1ac-536babe0da77",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/05Sleeves_Cap03.png",
    "description": "05Sleeves_Cap03",
    "imageId": "8e55a272-1b7c-4eed-aa70-d903da9fca05",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/05Sleeves_Cap03_X2.png",
    "description": "05Sleeves_Cap03_X2",
    "imageId": "4ebcd27e-e5f8-49a4-b0aa-20c2ef6d6450",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/06Sleeves_Long03.png",
    "description": "06Sleeves_Long03",
    "imageId": "a3f386e2-dc66-43f5-8534-7c0589ba5a92",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/06Sleeves_Long03_X2.png",
    "description": "06Sleeves_Long03_X2",
    "imageId": "7717eb8a-2083-43a3-aa7b-aff665af1f47",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/07Sleeves_Short02.png",
    "description": "07Sleeves_Short02",
    "imageId": "d15eeb0c-eb8a-4e3b-a065-fb7858de5569",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/07Sleeves_Short02_X2.png",
    "description": "07Sleeves_Short02_X2",
    "imageId": "42e83b9a-6b56-44b8-b46d-2a8fde64380b",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/08Sleeves_SpaghettiStraps04.png",
    "description": "08Sleeves_SpaghettiStraps04",
    "imageId": "3ef2a26a-e617-4c54-aca7-527cc4242ac1",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/08Sleeves_SpaghettiStraps04_X2.png",
    "description": "08Sleeves_SpaghettiStraps04_X2",
    "imageId": "65c910c7-bee6-4f6f-9fd3-b7ea0d6aba05",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/09Sleeves_Sleeveless03.png",
    "description": "09Sleeves_Sleeveless03",
    "imageId": "9481c4c8-e33e-4420-9bd4-a628301b247d",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/09Sleeves_Sleeveless03_X2.png",
    "description": "09Sleeves_Sleeveless03_X2",
    "imageId": "26be69cc-b37b-408a-9d7f-047c4a98774a",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/10Sleeves_Cap04.png",
    "description": "10Sleeves_Cap04",
    "imageId": "2328ee05-56d7-48c7-b22d-93f9480875a8",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/10Sleeves_Cap04_X2.png",
    "description": "10Sleeves_Cap04_X2",
    "imageId": "9dbb0323-acb0-48cf-a121-db28926711ec",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/11Sleeves_Strapless04.png",
    "description": "11Sleeves_Strapless04",
    "imageId": "069856eb-12ab-4363-92e4-56009e27e4fb",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/11Sleeves_Strapless04_X2.png",
    "description": "11Sleeves_Strapless04_X2",
    "imageId": "1db4a576-e439-47ac-b489-077cf66e32b8",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/12Sleeves_Long04.png",
    "description": "12Sleeves_Long04",
    "imageId": "cc9ea92d-a290-4e1a-9d1a-2eb2027e2e97",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/12Sleeves_Long04_X2.png",
    "description": "12Sleeves_Long04_X2",
    "imageId": "ad87ff81-3f76-4283-a00b-c561d5690267",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/13Sleeves_Puff01.png",
    "description": "13Sleeves_Puff01",
    "imageId": "8cab494e-4b07-4c79-86aa-88d5884d234a",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/13Sleeves_Puff01_X2.png",
    "description": "13Sleeves_Puff01_X2",
    "imageId": "95026a36-3a3e-418a-83cd-dc9d5a1750f1",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/14Sleeves_Detachable03.png",
    "description": "14Sleeves_Detachable03",
    "imageId": "0abcadbe-bba0-4978-bb48-3a73b3834c09",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/14Sleeves_Detachable03_X2.png",
    "description": "14Sleeves_Detachable03_X2",
    "imageId": "9de6a302-b24a-4c55-ac09-df29458b2afd",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/15Sleeves_Short03.png",
    "description": "15Sleeves_Short03",
    "imageId": "e53e5d90-73d2-420c-9b11-b95b35afa9da",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/15Sleeves_Short03_X2.png",
    "description": "15Sleeves_Short03_X2",
    "imageId": "a73c2960-06df-42cd-9556-19cddd4d0975",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/16Sleeves_SpaghettiStraps01.png",
    "description": "16Sleeves_SpaghettiStraps01",
    "imageId": "67c89ce2-c283-4cda-8ab1-57042883153e",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/16Sleeves_SpaghettiStraps01_X2.png",
    "description": "16Sleeves_SpaghettiStraps01_X2",
    "imageId": "7037bf54-4aee-4bc0-a41b-1c7f1c65428c",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/17Sleeves_Detachable01.png",
    "description": "17Sleeves_Detachable01",
    "imageId": "e04b5d53-c779-4fb2-b8bb-365cc6658743",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/17Sleeves_Detachable01_X2.png",
    "description": "17Sleeves_Detachable01_X2",
    "imageId": "bc2568ec-56d1-4a66-b17e-696942eb442c",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/18Sleeves_Illusion04.png",
    "description": "18Sleeves_Illusion04",
    "imageId": "e7d9a206-3e07-4296-8bc0-64af30ded386",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/18Sleeves_Illusion04_X2.png",
    "description": "18Sleeves_Illusion04_X2",
    "imageId": "1060f6fa-8ee5-408d-a178-2dc5ebbe82d0",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/19Sleeves_Cap02.png",
    "description": "19Sleeves_Cap02",
    "imageId": "7dc08ca5-69ef-45e2-b317-fa885925a82a",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/19Sleeves_Cap02_X2.png",
    "description": "19Sleeves_Cap02_X2",
    "imageId": "e7def4f5-f7a1-4420-b87a-a6ff0a21132d",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/20Sleeves_Long02.png",
    "description": "20Sleeves_Long02",
    "imageId": "790599ba-41aa-4518-a357-80c512fcacdd",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/20Sleeves_Long02_X2.png",
    "description": "20Sleeves_Long02_X2",
    "imageId": "1facc7a9-3316-4b5c-b1e1-868a290170ab",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/21Sleeves_Illusion01.png",
    "description": "21Sleeves_Illusion01",
    "imageId": "ebcbb472-010a-4e58-bf38-4e44f825004a",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/21Sleeves_Illusion01_X2.png",
    "description": "21Sleeves_Illusion01_X2",
    "imageId": "44e9fb09-223b-4f44-8fae-76afacaa3660",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/22Sleeves_Strapless02.png",
    "description": "22Sleeves_Strapless02",
    "imageId": "eba42e0f-527c-44b1-a3fb-8220f32d6f16",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/22Sleeves_Strapless02_X2.png",
    "description": "22Sleeves_Strapless02_X2",
    "imageId": "0337cfed-d1c6-4705-8151-0db7e111b63c",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/23Sleeves_Sleeveless04.png",
    "description": "23Sleeves_Sleeveless04",
    "imageId": "36d43374-bf6a-41dc-a752-8704c155bb60",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/23Sleeves_Sleeveless04_X2.png",
    "description": "23Sleeves_Sleeveless04_X2",
    "imageId": "62257c81-b1d6-450f-be35-2ed3275f1346",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/24Sleeves_Puff03.png",
    "description": "24Sleeves_Puff03",
    "imageId": "be63ae63-5476-4d7c-92f8-f09d8d37f885",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/24Sleeves_Puff03_X2.png",
    "description": "24Sleeves_Puff03_X2",
    "imageId": "f76c7b6b-48fd-41d3-a71b-ec883fc381f8",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/25Sleeves_Short04.png",
    "description": "25Sleeves_Short04",
    "imageId": "8a4507e7-8832-48f7-94f1-c899bcbcef3c",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/25Sleeves_Short04_X2.png",
    "description": "25Sleeves_Short04_X2",
    "imageId": "876c7bcd-24ca-44fe-abad-d620551159a2",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/26Sleeves_SpaghettiStraps02.png",
    "description": "26Sleeves_SpaghettiStraps02",
    "imageId": "49d22dfe-0526-4c9f-8411-ceca8fbb2b3d",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/26Sleeves_SpaghettiStraps02_X2.png",
    "description": "26Sleeves_SpaghettiStraps02_X2",
    "imageId": "65a1c5fe-504d-4f65-80e4-7591a6361e6f",
    "facet": "spaghetti_strap",
    "seoUrl": "spaghetti-strap"
  }, {
    "name": "./images/3-Sleeves/27Sleeves_Strapless01.png",
    "description": "27Sleeves_Strapless01",
    "imageId": "cb54ad88-091d-41a2-87aa-4457d2f44c04",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/27Sleeves_Strapless01_X2.png",
    "description": "27Sleeves_Strapless01_X2",
    "imageId": "bc2f0a01-51bb-4d44-a66a-3b6dc8529ebf",
    "facet": "strapless",
    "seoUrl": "strapless"
  }, {
    "name": "./images/3-Sleeves/28Sleeves_Detachable04.png",
    "description": "28Sleeves_Detachable04",
    "imageId": "b032f773-2dcf-4f8e-bdc2-9c626b7720ca",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/28Sleeves_Detachable04_X2.png",
    "description": "28Sleeves_Detachable04_X2",
    "imageId": "e881bf23-5456-4c58-99d3-121db3ab5a2d",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/29Sleeves_Cap01.png",
    "description": "29Sleeves_Cap01",
    "imageId": "461dfc49-68d0-428f-9613-37c890b6369c",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/29Sleeves_Cap01_X2.png",
    "description": "29Sleeves_Cap01_X2",
    "imageId": "58cfc3bf-ce7c-4dd0-988d-9e420f1f16cd",
    "facet": "cap_sleeves",
    "seoUrl": "cap-sleeve"
  }, {
    "name": "./images/3-Sleeves/30Sleeves_Puff02.png",
    "description": "30Sleeves_Puff02",
    "imageId": "354b717d-6c7d-44c1-ac53-3125eb935203",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/30Sleeves_Puff02_X2.png",
    "description": "30Sleeves_Puff02_X2",
    "imageId": "bd9538dc-6cee-43c4-aa2a-6c2bfa7a243c",
    "facet": "puff_sleeve",
    "seoUrl": "puff-sleeve"
  }, {
    "name": "./images/3-Sleeves/31Sleeves_Illusion02.png",
    "description": "31Sleeves_Illusion02",
    "imageId": "a528bf7e-0f01-4689-8082-8544d349e797",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/31Sleeves_Illusion02_X2.png",
    "description": "31Sleeves_Illusion02_X2",
    "imageId": "3a3c41d3-4386-4f94-8cb1-03c9d7df77aa",
    "facet": "illusion_sleeve",
    "seoUrl": "illusion-sleeve"
  }, {
    "name": "./images/3-Sleeves/32Sleeves_Sleeveless02.png",
    "description": "32Sleeves_Sleeveless02",
    "imageId": "c1ee170d-8efb-4fb4-b91a-bd4d41ae4de1",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/32Sleeves_Sleeveless02_X2.png",
    "description": "32Sleeves_Sleeveless02_X2",
    "imageId": "8aafacd3-6627-4dd3-bda7-d3c5520d5233",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/33Sleeves_Long01.png",
    "description": "33Sleeves_Long01",
    "imageId": "984bf5e8-e268-469c-8869-bcba8bcb311c",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/33Sleeves_Long01_X2.png",
    "description": "33Sleeves_Long01_X2",
    "imageId": "055a317e-b21b-40f4-bfb3-a3af2350ebe4",
    "facet": "long_sleeve",
    "seoUrl": "long-sleeve"
  }, {
    "name": "./images/3-Sleeves/34Sleeves_Detachable02.png",
    "description": "34Sleeves_Detachable02",
    "imageId": "8934894f-2188-4f16-8a48-e010e1426e56",
    "facet": "etachable_sleeve",
    "seoUrl": "etachable_sleeve"
  }, {
    "name": "./images/3-Sleeves/34Sleeves_Detachable02_X2.png",
    "description": "34Sleeves_Detachable02_X2",
    "imageId": "8635acb3-7234-426a-9876-963e9a4b9825",
    "facet": "detachable_sleeve",
    "seoUrl": "detachable-sleeve"
  }, {
    "name": "./images/3-Sleeves/35Sleeves_Sleeveless01.png",
    "description": "35Sleeves_Sleeveless01",
    "imageId": "9e1a1d5f-2a5a-47f5-b699-7630ec5cd3b3",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/35Sleeves_Sleeveless01_X2.png",
    "description": "35Sleeves_Sleeveless01_X2",
    "imageId": "fe9eb327-b9a4-4df9-baa2-2f2d5d4b110b",
    "facet": "sleeveless",
    "seoUrl": "sleeveless"
  }, {
    "name": "./images/3-Sleeves/36Sleeves_Short01.png",
    "description": "36Sleeves_Short01",
    "imageId": "dc921e73-9145-479b-9486-48adc753b8a8",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }, {
    "name": "./images/3-Sleeves/36Sleeves_Short01_X2.png",
    "description": "36Sleeves_Short01_X2",
    "imageId": "bd2d96e6-bb3c-4a62-b81e-f4e1bba1b3af",
    "facet": "short_sleeve",
    "seoUrl": "short-sleeve"
  }],
  "gown_length": [{
    "name": "./images/4-Length/01Length_Floor04.png",
    "description": "01Length_Floor04",
    "imageId": "ef85e799-daf2-4c44-ba83-3aaa1b3312e4",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/01Length_Floor04_X2.png",
    "description": "01Length_Floor04_X2",
    "imageId": "8a2e6dab-e94c-4457-8e3c-cf959d02e342",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/02Length_Short01.png",
    "description": "02Length_Short01",
    "imageId": "298097b4-6186-4991-8c2a-00f5190b40fd",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/02Length_Short01_X2.png",
    "description": "02Length_Short01_X2",
    "imageId": "ead60268-8978-4e05-8f1d-b08c19b66601",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/03Length_HighLow04.png",
    "description": "03Length_HighLow04",
    "imageId": "55920223-a351-485f-bdeb-402805a29553",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/03Length_HighLow04_X2.png",
    "description": "03Length_HighLow04_X2",
    "imageId": "06e2d97e-c2b9-455e-81ee-542e7f094e2b",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/04Length_Midi02.png",
    "description": "04Length_Midi02",
    "imageId": "b2aed6b3-e572-41ea-ae67-6ca25b5ecea8",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/04Length_Midi02_X2.png",
    "description": "04Length_Midi02_X2",
    "imageId": "fa934144-2843-4b49-b3ac-e42959b6f226",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/05Length_HighLow02.png",
    "description": "05Length_HighLow02",
    "imageId": "d38dae07-d313-4500-85d1-6aad340611a8",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/05Length_HighLow02_X2.png",
    "description": "05Length_HighLow02_X2",
    "imageId": "7da0da9e-dd6f-445f-a395-6fd6ab02f4cf",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/06Length_Tea01.png",
    "description": "06Length_Tea01",
    "imageId": "12052f22-67bc-4a3c-80b7-f01af90eaa07",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/06Length_Tea01_X2.png",
    "description": "06Length_Tea01_X2",
    "imageId": "aeeacb81-364f-419c-9ad4-b99706cc809a",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/07Length_Midi04.png",
    "description": "07Length_Midi04",
    "imageId": "2b344215-377d-4609-bc51-27a0abb1cc11",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/07Length_Midi04_X2.png",
    "description": "07Length_Midi04_X2",
    "imageId": "f2cbeda6-c3d4-4ef9-bc09-b124dcd5f4db",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/08Length_Short04.png",
    "description": "08Length_Short04",
    "imageId": "ac9a2c17-7f56-43a8-8d27-c4361b41b331",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/08Length_Short04_X2.png",
    "description": "08Length_Short04_X2",
    "imageId": "84737f1d-051d-4b22-a59c-7de46c6923fe",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/09Length_Tea02.png",
    "description": "09Length_Tea02",
    "imageId": "bed91980-937a-49f5-93a8-6daa68c1afbd",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/09Length_Tea02_X2.png",
    "description": "09Length_Tea02_X2",
    "imageId": "bb84b66a-1445-4bac-8b32-66764a0e4e6d",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/10Length_Midi03.png",
    "description": "10Length_Midi03",
    "imageId": "ab257165-4014-4752-9dbd-4ca0fbc4bee9",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/10Length_Midi03_X2.png",
    "description": "10Length_Midi03_X2",
    "imageId": "cd1ab56d-e1ba-40cf-968f-99c6f074b828",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/11Length_Floor02.png",
    "description": "11Length_Floor02",
    "imageId": "10d36e92-7f88-4c2f-be2c-5788773f4df7",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/11Length_Floor02_X2.png",
    "description": "11Length_Floor02_X2",
    "imageId": "24fda358-2554-48ee-8ac5-957339b29288",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/12Length_HighLow01.png",
    "description": "12Length_HighLow01",
    "imageId": "e240bb19-f427-4bbd-8fdf-fc3a8968e51a",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/12Length_HighLow01_X2.png",
    "description": "12Length_HighLow01_X2",
    "imageId": "d2d6278c-03ce-4109-ae84-7b0fd771f938",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/13Length_Short03.png",
    "description": "13Length_Short03",
    "imageId": "3f258042-ded4-4195-ab46-94b07c19f69a",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/13Length_Short03_X2.png",
    "description": "13Length_Short03_X2",
    "imageId": "b95e9a31-404d-4403-b348-02063704b44b",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/14Length_Floor01.png",
    "description": "14Length_Floor01",
    "imageId": "f6527fb9-0790-4b95-9bce-10e9f4b8fac0",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/14Length_Floor01_X2.png",
    "description": "14Length_Floor01_X2",
    "imageId": "199ff8f3-673c-4a08-9431-c5ccefdff22a",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/15Length_Midi01.png",
    "description": "15Length_Midi01",
    "imageId": "79169b9b-542d-4a6f-94bf-494276853dda",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/15Length_Midi01_X2.png",
    "description": "15Length_Midi01_X2",
    "imageId": "3bdab3b5-3157-46b5-bae1-d85343af9fa7",
    "facet": "midi",
    "seoUrl": "midi"
  }, {
    "name": "./images/4-Length/16Length_Tea03.png",
    "description": "16Length_Tea03",
    "imageId": "1b7dec65-40da-48b7-bd0b-18f1ed3f04aa",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/16Length_Tea03_X2.png",
    "description": "16Length_Tea03_X2",
    "imageId": "5fac1f95-4271-4c9c-b3d9-be7432b7a24b",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/17Length_HighLow03.png",
    "description": "17Length_HighLow03",
    "imageId": "2c2ce43f-db74-4824-9df6-064b6b7b33e3",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/17Length_HighLow03_X2.png",
    "description": "17Length_HighLow03_X2",
    "imageId": "5b91754a-2934-41ec-8c08-acf2c470a3d0",
    "facet": "high-low",
    "seoUrl": "high-low"
  }, {
    "name": "./images/4-Length/18Length_Tea04.png",
    "description": "18Length_Tea04",
    "imageId": "7066472c-4e54-490f-b7d5-765cbca07250",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/18Length_Tea04_X2.png",
    "description": "18Length_Tea04_X2",
    "imageId": "e2095877-996f-49c5-a995-fa268599c31b",
    "facet": "tea",
    "seoUrl": "tea-length"
  }, {
    "name": "./images/4-Length/19Length_Short02.png",
    "description": "19Length_Short02",
    "imageId": "543a2ae5-013c-46ca-a989-637f69ffab20",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/19Length_Short02_X2.png",
    "description": "19Length_Short02_X2",
    "imageId": "504df08c-7abd-48eb-9769-5ee4ab2d2996",
    "facet": "short",
    "seoUrl": "short"
  }, {
    "name": "./images/4-Length/20Length_Floor03.png",
    "description": "20Length_Floor03",
    "imageId": "508f5872-9196-4477-a9a5-9371ddbc8731",
    "facet": "floor",
    "seoUrl": "floor-length"
  }, {
    "name": "./images/4-Length/20Length_Floor03_X2.png",
    "description": "20Length_Floor03_X2",
    "imageId": "1461ffe7-4cdd-4801-988e-2cf8d95d64da",
    "facet": "floor",
    "seoUrl": "floor-length"
  }]
};